import lodash from "lodash";

export const getState = (state, param = null, defaultValue = null) =>
	lodash.get(state, 'configWarehouse.removeStaffInWarehouse' + (param ? '.' + param : ''), defaultValue);
